/*
 * Created Date: 16-01-2024, 10:20:57 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Thu Mar 07 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import React from 'react'
import { ROUTER_AUTH } from './const'
import { userRole } from '@App/Studio/app-config/const'

const Regiterlazy = React.lazy(() => import('../pages/Register'))
const LoginLazy = React.lazy(() => import('../pages/Login'))
const VerifyEmailLazy = React.lazy(() => import('../pages/VerifyEmail'))
const SendEmailForgotPasswordLazy = React.lazy(() => import('../pages/SendEmailForgotPassword'))
const ResetPasswordLazy = React.lazy(() => import('../pages/ResetPassword'))
// const OnboardingLazy = React.lazy(() => import('../../Workspace/System/pages/Onboarding'))
const WorkspacesLazy = React.lazy(() => import('../pages/Workspaces'))
const ForgotPasswordLazy = React.lazy(() => import('../pages/ForgotPassword'))
export const AuthRouterConfig = {
	auth: [userRole.guest],
	settings: {
		layout: {
			config: {
				header: {
					display: false
				},
				sidebar: {
					display: false
				},
				footer: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: ROUTER_AUTH.register,
			element: <Regiterlazy />
		},
		{
			path: ROUTER_AUTH.login,
			element: <LoginLazy />
		},
		{
			path: ROUTER_AUTH.verify_email,
			element: <VerifyEmailLazy />
		},
		{
			path: ROUTER_AUTH.forgot_password,
			element: <ForgotPasswordLazy />
		},
		{
			path: ROUTER_AUTH.forgot_password_send_email,
			element: <SendEmailForgotPasswordLazy />
		},
		{
			path: ROUTER_AUTH.reset_password,
			element: <ResetPasswordLazy />
		}
		// {
		// 	path: ROUTER_AUTH.onboarding,
		// 	element: <OnboardingLazy />
		// },
		// {
		// 	path: ROUTER_AUTH.workspaces,
		// 	element: <WorkspacesLazy />
		// }
	]
}
